var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Heading',{attrs:{"page":_vm.page}}),_c('div',{staticClass:"d-lg-flex mb-4 w-75"},[_c('div',{staticClass:"w-100 mt-4 mt-sm-0"},[_c('div',{staticClass:"py-3 px-2"},[_c('div',{staticClass:"row px-2"},[_c('JsonForm',{attrs:{"schema":_vm.schema,"formData":_vm.formData}})],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }